export const headerLiterals = {
  marketplacePanel: {
    buyNowLabel: "Buy Now",
    txHistoryLabel: "Transaction History",
    activeLoansLabel: "Active Loans",
    myActivityLabel: "My Activity",
  },
};
